import kiruProfile from "../assets/kiru_profile.jpeg";
import mixvoiceBg from "../assets/mixvoice_bg.png";
import textureBg from "../assets/texture_bg.jpg";

//Mock data for the Vocal Mixing Masterclass

export const instructor = {
  name: "Kiru",
  bio: "For over 7 years, Kiru has helped artists across India create industry-ready vocals for hip-hop, Bollywood, and indie music. This masterclass breaks down his real-world workflow for clarity, emotion, tuning, space, automation, and vocal craft.", 
  photo: kiruProfile,
  socialProof : [
    "Sukhwinder Singh",
    "Javed Ali",
    "Nakash Aziz",
    "Sonu Nigam",
    "Amaal Mallik",
    "Sonu Kakkar",
  ]
};

export const previewVideo = {
  vimeoId: "1192271519",
  embedUrl:
    "https://player.vimeo.com/video/1194921376?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
    title: "Review video 2",
};

// Locked accordion (landing page) — high-level topics only
export const lockedTopics = [
  {
    id: "topic-1",
    title: "Vocal Recording Foundations",
    duration: "47 min",
    subtopics: [
      "Microphone selection for character",
      "Treating untreated rooms",
      "Mic placement for tone control",
      "Working with the artist in the booth",
    ],
  },
  {
    id: "topic-2",
    title: "Surgical EQ & Tonal Shaping",
    duration: "1 hr 12 min",
    subtopics: [
      "Subtractive vs additive EQ",
      "Resonance hunting workflow",
      "Air, presence and bite zones",
      "Dynamic EQ for sibilance control",
    ],
  },
  {
    id: "topic-3",
    title: "Compression: Glue, Tone & Energy",
    duration: "58 min",
    subtopics: [
      "Serial vs parallel compression",
      "FET, opto, VCA — when and why",
      "Riding the vocal with automation",
      "Compression as a creative effect",
    ],
  },
  {
    id: "topic-4",
    title: "Advanced FX Chains",
    duration: "1 hr 24 min",
    subtopics: [
      "Reverb sends as a song element",
      "Slap, plate and chamber routing",
      "Pitch and modulation textures",
      "Distortion for emotion",
    ],
  },
  {
    id: "topic-5",
    title: "Mixing the Modern Pop Vocal",
    duration: "1 hr 06 min",
    subtopics: [
      "Stacking lead, doubles and ad-libs",
      "Vocal bus processing",
      "Sitting vocals in dense productions",
      "Final polish and loudness",
    ],
  },
];


export const pricing = {
  plan: "Full Access",
  badge: "Masterclass Tier",
  priceLabel: "₹1,599",
  pricePeriod: "/ month",
  description: "One subscription. Every lesson. Every session file. Forever updates.",
  features: [
    "4+ hours of HD studio lessons",
    "Downloadable multitrack sessions",
    "Plugin-agnostic techniques",
    "Lifetime course updates",
    "Direct WhatsApp Support (1:1)",
  ],
};

export const heroBackground = mixvoiceBg;

export const textureBackground = textureBg;
